<section class="dz-card" [class.dz-card--recolhido]="!aberto()">
  <div class="dz-card__head">
    <h2 class="dz-card__title">
      <button
        type="button"
        class="dz-card__toggle"
        [attr.aria-expanded]="aberto()"
        aria-controls="registro-socios-corpo"
        [title]="aberto() ? 'Recolher' : 'Expandir'"
        (click)="aberto.set(!aberto())">
        <span class="dz-card__icon" aria-hidden="true">👥</span>
        Sócios ({{ socios().length }})
        <i class="pi pi-chevron-down dz-card__chevron" aria-hidden="true"></i>
      </button>
    </h2>
  </div>

  <div class="dz-card__body" id="registro-socios-corpo" [hidden]="!aberto()">
    @if (socios().length) {
      <div class="qsa">
        <table class="qsa__table">
          <thead>
            <tr>
              <th class="dz-label">Nome</th>
              <th class="dz-label">Documento</th>
              <th class="dz-label">Qualificação</th>
              <th class="dz-label">Entrada</th>
              <th class="dz-label">Faixa etária</th>
              <th class="dz-label">País</th>
            </tr>
          </thead>
          <tbody>
            @for (s of socios(); track $index) {
              <tr>
                <td>
                  <span class="qsa__name">{{ s.nome }}</span>
                  @if (s.nomeRepresentante) {
                    <span class="qsa__rep">
                      Rep.: {{ s.nomeRepresentante }}
                      @if (s.qualificacaoRepresentante) {
                        — {{ s.qualificacaoRepresentante }}
                      }
                    </span>
                  }
                </td>
                <td class="qsa__doc dz-mono">{{ documento(s.documento) ?? '—' }}</td>
                <td class="qsa__soft">{{ s.qualificacao ?? '—' }}</td>
                <td class="qsa__soft qsa__num">
                  {{ s.dataEntrada ? (s.dataEntrada | vaultDate) : '—' }}
                </td>
                <td class="qsa__soft">{{ s.faixaEtaria ?? '—' }}</td>
                <td class="qsa__soft">{{ s.pais ?? '—' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <p class="dz-muted">Nenhum sócio registrado.</p>
    }
  </div>
</section>
